<template>
  <div>
    <!-- DESACTIVADAS A PEDIDO DEL CLIENTE -->
    <!-- <section class="section is-hidden-mobile">
      <div class="container">
      <b-carousel
            v-model="carousel.carousel"
            indicator-style="is-boxes"
            :arrow="carousel.arrow"
            :arrow-hover="carousel.arrowHover"
            :animated="carousel.animated"
            :autoplay="carousel.autoPlay"
            :pause-hover="carousel.pauseHover"
            :pause-info="carousel.pauseInfo"
            :indicator="carousel.indicator"
            :interval="carousel.interval">
            <b-carousel-item>
                <figure class="image">
                  <img
                    class="is-circular"
                    src="@/assets/img/carousel/cuarentena.png"
                    alt
                  >
                </figure>
            </b-carousel-item>
            <b-carousel-item>
                <figure class="image">
                  <img
                    class="is-circular"
                    src="@/assets/img/carousel/1.png"
                    alt
                  >
                </figure>
            </b-carousel-item>
            <b-carousel-item>
              <router-link :to="{name: 'subir-fotos'}">
                <figure class="image">
                    <img
                      class="is-circular"
                      src="@/assets/img/carousel/2.png"
                      alt
                    >
                  </figure>
              </router-link>
            </b-carousel-item>
            <b-carousel-item>
              <figure class="image">
              <img
                class="is-circular"
                src="@/assets/img/carousel/3.png"
                alt
              >
            </figure>
            </b-carousel-item>
            <b-carousel-item>
              <a href="http://tienda.mundofotografico.com.ar">
              <figure class="image">
               <img
                  class="is-circular"
                  src="@/assets/img/carousel/4.png"
                  alt
                >
              </figure>
            </a>
            </b-carousel-item>
        </b-carousel>
      </div>
    </section> -->
    <section class="section section-cards is-hidden-tablet">
      <div class="container">
        <div class="columns is-multiline is-centered">
          <div class="column is-4">
            <div class="card">
              <router-link :to="{name: 'subir-fotos'}">
                <div class="card-image">
                  <figure class="image is-square">
                    <img src="@/assets/img/cards/4.png" />
                  </figure>
                </div>
              </router-link>
            </div>
          </div>
          <div class="column is-4">
            <div class="card">
              <a href="#" @click="lanzarModalSelectorProducto">
                <div class="card-image">
                  <figure class="image is-square">
                    <img src="@/assets/img/cards/5.png" />
                  </figure>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.is-circular {
  border-radius: 10px;
}
.carousel-caption {
  color: #fff;
  text-align: left;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  margin-top: 0.75em;
  margin-left: 2em;
}
.left-button {
  right: 2em;
}
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: scale(1.05);
}
.section-cards {
  margin-top: 1.3rem;
}
.card {
  box-shadow: 0 0.5em 1em -0.125em grey, 0 0px 0 1px grey;
}
</style>

<script>
import SelectorTipoProducto from '@/components/SelectorTipoProducto'

export default {
  name: 'CarouselPropio',
  data () {
    return {
      carousel: {
        arrow: true,
        arrowHover: false,
        carousel: 0,
        animated: 'slide',
        autoPlay: process.env.VUE_APP_AUTOPLAY_CAROUSEL === 'true',
        pauseHover: false,
        pauseInfo: false,
        interval: 3000,
        indicator: true
      }
    }
  },
  methods: {
    lanzarModalSelectorProducto () {
      this.$buefy.modal.open({
        parent: this,
        component: SelectorTipoProducto,
        trapFocus: true
      })
    }
  }
}
</script>
